var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppNavigationItem',{attrs:{"title":_vm.title},on:{"click":_vm.toggleCollapse}})}
var staticRenderFns = []

export { render, staticRenderFns }